module.exports = __webpack_public_path__ + "media/images/redesign-images/higher-ed/event-02-9123fa62fdf6a295d3cc66a509c18a1b.jpg";